import React from "react";
import { getAuthenticatedUser } from "@edx/frontend-platform/auth";
import Cookies from "universal-cookie";
import { getConfig } from "@edx/frontend-platform";
import useIsSpeechCraftMFE from "../hooks/useIsSpeechcraftMFE";
import { Levels } from "../config/index";
import { Dropdown } from "@openedx/paragon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";

import { ReactComponent as AppsIcon } from "../tab-page/svgs/appsIcon.svg";
import NotificationMenu from "../tab-page/NotificationMenu";
import HeaderDrawer from "./HeaderDrawer";

function CustomHeader({ org, number, title, name }) {
  const user = getAuthenticatedUser();
  const isSpeechCraftMFE = useIsSpeechCraftMFE();
  const cookies = new Cookies();
  const { roles = [] } = user;

  const isLevelOneUser =
    JSON.stringify(roles) === "[]" && JSON.stringify(user) !== "{}";
  const isLevelFourUser = roles.includes(Levels.level4);
  const isLevelFiveUser = roles.includes(Levels.level5);
  const isLevelTwoUser = roles.includes(Levels.level2);
  const isLevelThreeUser = roles.includes(Levels.level3);
  const hasLibraryOrStudioAccess =
    isLevelFourUser || isLevelFiveUser || user.administrator;
  const assetsManagementUrl = `${`${getConfig().PANEL_BASE_URL}`}${
    isLevelThreeUser
      ? "/support/impersonate"
      : isLevelTwoUser
      ? "/support/member-transcript"
      : ""
  }`;

  const handleLogout = () => {
    cookies.remove("csrftoken", { path: getConfig().LOGOUT_URL });
    window.location.replace(getConfig().LOGOUT_URL);
  };

  const BASE_URL = isSpeechCraftMFE
    ? getConfig().SPEECHCRAFT_MFE_BASE_URL
    : getConfig().DASHBOARD_MFE_BASE_URL;

  return (
    <header className="learning-header">
      <a className="sr-only sr-only-focusable" href="#main-content">
        Skip to main content.
      </a>
      <div className="container-xl py-2 d-flex align-items-center">
        <HeaderDrawer />
        <a
          className="logo"
          href={
            getConfig()[
              isSpeechCraftMFE
                ? "SPEECHCRAFT_MFE_BASE_URL"
                : "DASHBOARD_MFE_BASE_URL"
            ]
          }
        >
          <img
            className="d-block"
            src={`${getConfig()[isSpeechCraftMFE ? "SPEECHCRAFT_LOGO_URL" : "PATHWAYS_LOGO_URL"]}?ver=${Math.floor(Math.random() * 99)}`}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = getConfig()["LOGO_URL"];
            }}
            alt="Toastmasters International"
          />
        </a>

        <div className="flex-md-grow-1 course-title-lockup">
          <div className="d-block small m-0">
            <div>
              <div className="d-none d-lg-inline-block">{org}</div>
              <div className="d-none d-lg-inline-block">{number}</div>
            </div>
            {!isLevelOneUser && (
              <div className="app-menu-wrapper d-none d-md-block">
                <Dropdown className="app-menu-dropdown">
                  <Dropdown.Toggle
                    id="app-menu-dropdown-toggle"
                    aria-label="App Menu"
                    className="app-menu-btn"
                  >
                    <span className="material-icons">
                      <AppsIcon />
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu popperConfig={{ fixed: true }}>
                    {hasLibraryOrStudioAccess && (
                      <>
                        <Dropdown.Item href={`${getConfig().STUDIO_BASE_URL}`}>
                          Studio
                        </Dropdown.Item>
                        <Dropdown.Item href={`${getConfig().LIBRARY_BASE_URL}`}>
                          Library
                        </Dropdown.Item>
                      </>
                    )}
                    <Dropdown.Item href={assetsManagementUrl}>
                      Assets Management
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
            <NotificationMenu />
          </div>
          <div className="d-block m-0 font-weight-bold course-title">
            <div className="d-none d-lg-block">{title}</div>
          </div>
        </div>

        {/* <a className="text-gray-700 ml-3 mr-3" href="https://support.edx.org">Help</a> */}

        <Dropdown className="user-dropdown d-none d-md-block">
          <Dropdown.Toggle id="user-dropdown-toggle" aria-label="account of current user" variant="outline-primary">
            <FontAwesomeIcon className="fa-lg d-md-none" icon={faUserCircle} />
            <span className="d-none d-md-inline">{name}</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              href="#"
              onClick={() => {
                window.location.assign(BASE_URL);
              }}
            >
              Dashboard
            </Dropdown.Item>
            <Dropdown.Item
              href="#"
              className="error-item"
              onClick={handleLogout}
            >
              Sign Out
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
}

export default CustomHeader;
